// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { HistoryFeedInfoFragmentDoc, TradePartnerFragmentDoc, TradePartnerContactFragmentDoc, PotentialOperationDetailsFragmentDoc, ChangeEventTypeFragmentDoc } from '../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GlobalOptionsPageMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GlobalOptionsPageMetadataQuery = { __typename?: 'Query', globalOptionTypes: Array<{ __typename?: 'GlobalOptionType', id: string, name: string }>, locations: Array<{ __typename?: 'Location', id: string, name: string }>, developments: Array<{ __typename?: 'Development', id: string, name: string }> };

export type GlobalOptionsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.GlobalOptionsFilter>;
}>;


export type GlobalOptionsQuery = { __typename?: 'Query', globalOptions: Array<{ __typename?: 'GlobalOption', activeDate?: Types.Scalars['Date']['input'] | null | undefined, archivedDate?: Types.Scalars['Date']['input'] | null | undefined, code: string, id: string, name: string, type: { __typename?: 'GlobalOptionType', version: number, id: string, name: string }, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, isSingleOptionGroup: boolean }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }>, supportedTags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }>, canEditLocations: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEditType: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string, development?: { __typename?: 'Development', id: string, name: string } | null | undefined } }> }> };

export type GlobalOptionsIdsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GlobalOptionsIdsQuery = { __typename?: 'Query', globalOptions: Array<{ __typename?: 'GlobalOption', code: string, id: string, name: string }> };

export type SaveGlobalOptionsMutationVariables = Types.Exact<{
  globalOptions: Array<Types.SaveGlobalOptionInput> | Types.SaveGlobalOptionInput;
}>;


export type SaveGlobalOptionsMutation = { __typename?: 'Mutation', saveGlobalOptions: { __typename?: 'SaveGlobalOptionsResult', globalOptions: Array<{ __typename?: 'GlobalOption', activeDate?: Types.Scalars['Date']['input'] | null | undefined, archivedDate?: Types.Scalars['Date']['input'] | null | undefined, code: string, id: string, name: string, type: { __typename?: 'GlobalOptionType', version: number, id: string, name: string }, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, isSingleOptionGroup: boolean }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }>, supportedTags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }>, canEditLocations: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEditType: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string, development?: { __typename?: 'Development', id: string, name: string } | null | undefined } }> }> } };

export type GlobalOptionsDetailFragment = { __typename?: 'GlobalOption', activeDate?: Types.Scalars['Date']['input'] | null | undefined, archivedDate?: Types.Scalars['Date']['input'] | null | undefined, code: string, id: string, name: string, type: { __typename?: 'GlobalOptionType', version: number, id: string, name: string }, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, isSingleOptionGroup: boolean }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }>, supportedTags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }>, canEditLocations: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEditType: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string, development?: { __typename?: 'Development', id: string, name: string } | null | undefined } }> };

export type GlobalOptionTagDetailFragment = { __typename?: 'GlobalOptionTag', id: string, name: string };

export type GlobalOptionsIdsDetailsFragment = { __typename?: 'GlobalOption', code: string, id: string, name: string };

export type GlobalOptionDetail_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, active: boolean, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string, development?: { __typename?: 'Development', id: string, name: string } | null | undefined } };

export const GlobalOptionsIdsDetailsFragmentDoc = gql`
    fragment GlobalOptionsIdsDetails on GlobalOption {
  ...Named
  code
}
    ${NamedFragmentDoc}`;
export const GlobalOptionTagDetailFragmentDoc = gql`
    fragment GlobalOptionTagDetail on GlobalOptionTag {
  id
  name
}
    `;
export const GlobalOptionDetail_ReadyPlanOptionFragmentDoc = gql`
    fragment GlobalOptionDetail_ReadyPlanOption on ReadyPlanOption {
  id
  active
  readyPlan {
    ...Named
    development {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;
export const GlobalOptionsDetailFragmentDoc = gql`
    fragment GlobalOptionsDetail on GlobalOption {
  ...GlobalOptionsIdsDetails
  type {
    ...Named
    version
  }
  group {
    id
    name
    isSingleOptionGroup
  }
  locations {
    id
    name
  }
  statusDetail {
    code
    name
  }
  activeDate
  archivedDate
  tags {
    ...GlobalOptionTagDetail
  }
  supportedTags {
    ...GlobalOptionTagDetail
  }
  canEditLocations {
    ...PotentialOperationDetails
  }
  canEditType {
    ...PotentialOperationDetails
  }
  readyPlanOptions {
    ...GlobalOptionDetail_ReadyPlanOption
  }
}
    ${GlobalOptionsIdsDetailsFragmentDoc}
${NamedFragmentDoc}
${GlobalOptionTagDetailFragmentDoc}
${PotentialOperationDetailsFragmentDoc}
${GlobalOptionDetail_ReadyPlanOptionFragmentDoc}`;
export const GlobalOptionsPageMetadataDocument = gql`
    query GlobalOptionsPageMetadata {
  globalOptionTypes(filter: {version: [1, 2]}) {
    ...Named
  }
  locations {
    ...Named
  }
  developments {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useGlobalOptionsPageMetadataQuery__
 *
 * To run a query within a React component, call `useGlobalOptionsPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOptionsPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOptionsPageMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalOptionsPageMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalOptionsPageMetadataQuery, GlobalOptionsPageMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalOptionsPageMetadataQuery, GlobalOptionsPageMetadataQueryVariables>(GlobalOptionsPageMetadataDocument, options);
      }
export function useGlobalOptionsPageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalOptionsPageMetadataQuery, GlobalOptionsPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalOptionsPageMetadataQuery, GlobalOptionsPageMetadataQueryVariables>(GlobalOptionsPageMetadataDocument, options);
        }
// @ts-ignore
export function useGlobalOptionsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsPageMetadataQuery, GlobalOptionsPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionsPageMetadataQuery, GlobalOptionsPageMetadataQueryVariables>;
export function useGlobalOptionsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsPageMetadataQuery, GlobalOptionsPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionsPageMetadataQuery | undefined, GlobalOptionsPageMetadataQueryVariables>;
export function useGlobalOptionsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsPageMetadataQuery, GlobalOptionsPageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalOptionsPageMetadataQuery, GlobalOptionsPageMetadataQueryVariables>(GlobalOptionsPageMetadataDocument, options);
        }
export type GlobalOptionsPageMetadataQueryHookResult = ReturnType<typeof useGlobalOptionsPageMetadataQuery>;
export type GlobalOptionsPageMetadataLazyQueryHookResult = ReturnType<typeof useGlobalOptionsPageMetadataLazyQuery>;
export type GlobalOptionsPageMetadataSuspenseQueryHookResult = ReturnType<typeof useGlobalOptionsPageMetadataSuspenseQuery>;
export type GlobalOptionsPageMetadataQueryResult = Apollo.QueryResult<GlobalOptionsPageMetadataQuery, GlobalOptionsPageMetadataQueryVariables>;
export const GlobalOptionsDocument = gql`
    query GlobalOptions($filter: GlobalOptionsFilter) {
  globalOptions(filter: $filter) {
    ...GlobalOptionsDetail
  }
}
    ${GlobalOptionsDetailFragmentDoc}`;

/**
 * __useGlobalOptionsQuery__
 *
 * To run a query within a React component, call `useGlobalOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGlobalOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalOptionsQuery, GlobalOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalOptionsQuery, GlobalOptionsQueryVariables>(GlobalOptionsDocument, options);
      }
export function useGlobalOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalOptionsQuery, GlobalOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalOptionsQuery, GlobalOptionsQueryVariables>(GlobalOptionsDocument, options);
        }
// @ts-ignore
export function useGlobalOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsQuery, GlobalOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionsQuery, GlobalOptionsQueryVariables>;
export function useGlobalOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsQuery, GlobalOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionsQuery | undefined, GlobalOptionsQueryVariables>;
export function useGlobalOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsQuery, GlobalOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalOptionsQuery, GlobalOptionsQueryVariables>(GlobalOptionsDocument, options);
        }
export type GlobalOptionsQueryHookResult = ReturnType<typeof useGlobalOptionsQuery>;
export type GlobalOptionsLazyQueryHookResult = ReturnType<typeof useGlobalOptionsLazyQuery>;
export type GlobalOptionsSuspenseQueryHookResult = ReturnType<typeof useGlobalOptionsSuspenseQuery>;
export type GlobalOptionsQueryResult = Apollo.QueryResult<GlobalOptionsQuery, GlobalOptionsQueryVariables>;
export const GlobalOptionsIdsDocument = gql`
    query GlobalOptionsIds {
  globalOptions {
    ...GlobalOptionsIdsDetails
  }
}
    ${GlobalOptionsIdsDetailsFragmentDoc}`;

/**
 * __useGlobalOptionsIdsQuery__
 *
 * To run a query within a React component, call `useGlobalOptionsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOptionsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOptionsIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalOptionsIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalOptionsIdsQuery, GlobalOptionsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalOptionsIdsQuery, GlobalOptionsIdsQueryVariables>(GlobalOptionsIdsDocument, options);
      }
export function useGlobalOptionsIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalOptionsIdsQuery, GlobalOptionsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalOptionsIdsQuery, GlobalOptionsIdsQueryVariables>(GlobalOptionsIdsDocument, options);
        }
// @ts-ignore
export function useGlobalOptionsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsIdsQuery, GlobalOptionsIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionsIdsQuery, GlobalOptionsIdsQueryVariables>;
export function useGlobalOptionsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsIdsQuery, GlobalOptionsIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionsIdsQuery | undefined, GlobalOptionsIdsQueryVariables>;
export function useGlobalOptionsIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsIdsQuery, GlobalOptionsIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalOptionsIdsQuery, GlobalOptionsIdsQueryVariables>(GlobalOptionsIdsDocument, options);
        }
export type GlobalOptionsIdsQueryHookResult = ReturnType<typeof useGlobalOptionsIdsQuery>;
export type GlobalOptionsIdsLazyQueryHookResult = ReturnType<typeof useGlobalOptionsIdsLazyQuery>;
export type GlobalOptionsIdsSuspenseQueryHookResult = ReturnType<typeof useGlobalOptionsIdsSuspenseQuery>;
export type GlobalOptionsIdsQueryResult = Apollo.QueryResult<GlobalOptionsIdsQuery, GlobalOptionsIdsQueryVariables>;
export const SaveGlobalOptionsDocument = gql`
    mutation SaveGlobalOptions($globalOptions: [SaveGlobalOptionInput!]!) {
  saveGlobalOptions(input: {globalOptions: $globalOptions}) {
    globalOptions {
      ...GlobalOptionsDetail
    }
  }
}
    ${GlobalOptionsDetailFragmentDoc}`;
export type SaveGlobalOptionsMutationFn = Apollo.MutationFunction<SaveGlobalOptionsMutation, SaveGlobalOptionsMutationVariables>;

/**
 * __useSaveGlobalOptionsMutation__
 *
 * To run a mutation, you first call `useSaveGlobalOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalOptionsMutation, { data, loading, error }] = useSaveGlobalOptionsMutation({
 *   variables: {
 *      globalOptions: // value for 'globalOptions'
 *   },
 * });
 */
export function useSaveGlobalOptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGlobalOptionsMutation, SaveGlobalOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGlobalOptionsMutation, SaveGlobalOptionsMutationVariables>(SaveGlobalOptionsDocument, options);
      }
export type SaveGlobalOptionsMutationHookResult = ReturnType<typeof useSaveGlobalOptionsMutation>;
export type SaveGlobalOptionsMutationResult = Apollo.MutationResult<SaveGlobalOptionsMutation>;
export type SaveGlobalOptionsMutationOptions = Apollo.BaseMutationOptions<SaveGlobalOptionsMutation, SaveGlobalOptionsMutationVariables>;